/* eslint-disable camelcase */
// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

// app modules: components
import CollectionImage from 'components/CollectionImage';
import CollectionOptionsMenu from 'components/Collection/OptionsMenu';
import FavouriteButton from 'components/FavouriteButton';
import Icon from 'components/Icon';
import Link from 'components/Link';

// app modules: props
import CollectionsProps from 'components/Collection/CollectionsProps';

// app modules: services
import route from 'services/route';

// app modules: constants
import { COLOURS, CONTENT_TYPES } from 'constants/index';

// assets
import CssDetailedCollectionItem from './DetailedCollectionItem.scss';

class DetailedCollectionItem extends PureComponent {
  static propTypes = {
    item: CollectionsProps.collection.isRequired,
    referrer: PropTypes.string,
    section: PropTypes.string,
  };

  static defaultProps = {
    referrer: null,
    section: null,
  };

  render() {
    const { referrer, section } = this.props;
    const collection = this.props.item;
    const { items_count } = collection;

    const image = (
      <CollectionImage
        mobileAsThumbnail
        contentImage={collection.cover_image}
        overrideImage={collection.custom_cover_image}
        width={250}
        height={250}
        bookCoverWidth={175}
        bookCoverHeight={175}
      />
    );

    return (
      <div className="detailed-collection-item">
        <div className="detailed-collection-item__body">
          <div className="detailed-collection-item__image">
            <Link to={route.collection.view(collection)} referrer={referrer} section={section}>
              {image}
            </Link>
          </div>

          <div className="detailed-collection-item__content">
            <header className="detailed-collection-item__header">
              <Link to={route.collection.view(collection)} referrer={referrer} section={section}>
                {collection.name}
              </Link>
            </header>

            <p className="detailed-collection-item__description">{collection.description}</p>

            <div className="detailed-collection-item__spacer" />

            <footer className="detailed-collection-item__footer">
              <div>
                {collection.display_name && !collection.display_name.includes('@') ? (
                  <p className="detailed-collection-item__paragraph">{collection.display_name}</p>
                ) : null}
                {items_count && typeof items_count.total === 'number' ? (
                  <p className="detailed-collection-item__paragraph">
                    {`${items_count.total} ${items_count.total === 1 ? 'item' : 'items'}`}
                  </p>
                ) : null}
              </div>
              <div className="detailed-collection-item__actions">
                <FavouriteButton
                  contentId={`${collection.id}`}
                  contentType={CONTENT_TYPES.COLLECTION}
                />
                <CollectionOptionsMenu
                  collection={collection}
                  image={image}
                  heading={collection.name}
                >
                  <Icon fill={COLOURS.ENERGIZED} name="dots" height="20" width="20"/>
                </CollectionOptionsMenu>
              </div>
            </footer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(CssDetailedCollectionItem)(DetailedCollectionItem);
